import { gql } from '@apollo/client';

export default gql`
  mutation ResendSystemAction($id: Int!) {
    resendSystemAction(id: $id) {
      success
      message
      # RITA-1316: false ONLY when the mail went out but its durable record rolled back in
      # the COMMIT phase. The row then still LOOKS resendable, so this flag tells the client
      # to lock the action and ask for a reload instead of re-enabling it (which would invite
      # a duplicate send) — null/true means the resend committed normally (Codex Review P1).
      committed
      # Deliberately NO history selection here. Apollo normalizes log_entry by id and
      # merges this payload into the SystemAccessLogEntry already cached by
      # GetAdvisorSystemLog. Writing the mutation history back would clobber that cached
      # audit trail: the freshly appended resent row arrives without the snapshot and
      # triggered_by fields the detail view renders (blank entry), and in the tolerated
      # "resend ok + log refetch failed" path the best-effort backend read can even
      # degrade to an empty list, wiping the whole trail until a later refresh (Codex
      # Review P1). The authoritative history update comes from the panel refetchLog
      # (gated by the resend latch), exactly like executeSystemAction which also omits it.
      #
      # We DO select the resend-time mail header snapshots the backend attaches
      # (recipient_email / mail_from / current_subject resolve off the row's resend
      # snapshots). Merging these scalars into the cache is correct — they are the values
      # this resend actually used — and it keeps the open detail header (An:/Von:/Betreff)
      # in sync even in the tolerated "resend ok + refetch failed" path, instead of leaving
      # the pre-resend (or blank) header on a mail that already went out (Codex Review P1).
      # Unlike history these are single values, so there is no audit-trail to clobber.
      log_entry {
        id
        process_status
        executed_at
        recipient_email
        mail_from
        current_subject
      }
    }
  }
`;
